import { ServiceCoursesMock } from "./ServiceCoursesMock";
import { ServiceCoursesApi } from "./ServiceCoursesApi";
import { IMsalContext } from "@azure/msal-react";
import { Lang } from "contexts/LanguageContext";

export default interface IServiceCoursesProvider {
    getFeaturedCourses(): Promise<any>;
    getCoursesByMonth(month: string): Promise<any>;
    getCourseById(courseId: string): Promise<any>;
    getCoursesCategories(): Promise<any>;
    getParticipations(msal: IMsalContext, lang: any, sessionId: string): Promise<any>;
    getPresences(msal: IMsalContext, lang: Lang): Promise<any>;
    getRegistrations(msal: IMsalContext, lang: Lang): Promise<any>;
    getTypesSubscription(msal: IMsalContext, lang: Lang): Promise<any>;
    sendSubscription(msal: IMsalContext, lang: Lang, dataToSend: any): Promise<any>;
    getSubscriptions(msal: IMsalContext, lang: Lang): Promise<any>;
    createSubscription(msal: IMsalContext, lang: Lang): Promise<any>;
    updateSubscription(msal: IMsalContext, lang: Lang, invitationCode: string | null): Promise<any>;
    assistSession(msal: IMsalContext, lang: Lang, sessionId: string, subscriptionId: string): Promise<any>;
}

export class ServiceCoursesProvider {
    private static _serviceCoursesProvider: IServiceCoursesProvider;
    // Mode du service, à mettre entre prod ou mock selon le besoin.
    private static _mode: "mock" | "prod" = process.env.REACT_APP_MODE as "mock" | "prod";

    public static get provider(): IServiceCoursesProvider {
        if (!this._serviceCoursesProvider) {
            if (this._mode == "mock") {
                this._serviceCoursesProvider = new ServiceCoursesMock;
            } else {
                this._serviceCoursesProvider = new ServiceCoursesApi;
            }
        }
        return this._serviceCoursesProvider;
    }
}